const Role = {
  ADMIN: 'Administrator',
  USER: 'User',
  COMPANY_ADMIN: 'CompanyAdmin',
}

export default Role
